import React from "react";
import Toast, {
  ErrorToast,
  SuccessToast,
  InfoToast,
} from "react-native-toast-message";

export const toastConfig = {
  error: ({ props }) => (
    <ErrorToast
      {...props}
      style={{ borderLeftColor: "red", width: "fit-content", minWidth: "15%" }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{ fontSize: 14 }}
      text2Style={{ fontSize: 12 }}
      useNativeDriver
    />
  ),
  success: ({ props }) => (
    <SuccessToast
      {...props}
      style={{
        borderLeftColor: "green",
        width: "fit-content",
        minWidth: "15%",
      }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{ fontSize: 14 }}
      text2Style={{ fontSize: 12 }}
      useNativeDriver
    />
  ),
  info: ({ props }) => (
    <InfoToast
      {...props}
      style={{
        borderLeftColor: "yellow",
        width: "fit-content",
        minWidth: "15%",
      }}
      contentContainerStyle={{ paddingHorizontal: 15 }}
      text1Style={{ fontSize: 14 }}
      text2Style={{ fontSize: 12 }}
      useNativeDriver
    />
  ),
};

export const toastInstance = (
  type: "error" | "success" | "info",
  message: string
) => {
  const mapString = {
    error: "ERROR",
    success: "SUCCESS",
    info: "ATTENTION",
  };

  const toastObjectConstructor: any = {
    type,
    visibilityTime: 5000,
    props: {
      text1: mapString[type],
      text2: message,
    },
  };

  return Toast.show(toastObjectConstructor);
};
